//import angular from 'angular';
import OcDateSvc from '../../../../../services/ocDateSvc';
import tmpl from './editVehicleEndDate.html';


angular.module("app.site").component("editVehicleEndDate",
        {
            template: tmpl,
            bindings: {
                initParams: '=',
                buttonMethods: '=',
                buttonStates: '=',
                buttons: '=',
                closeOnSave: '=',
                wnd: '='
            },
            controller: editVehicleEndDateCtrl
        });

    // @ts-ignore
    editVehicleEndDateCtrl.$inject = ['$scope', 'amtConstants', 'amtCommandQuerySvc', 'confirmSvc', 'enums', 'amtXlatSvc', 'notifySvc', 'WindowFactory', 'ocDateSvc', 'errorReporter'];

    function editVehicleEndDateCtrl($scope, amtConstants, amtCommandQuerySvc, confirmSvc, enums, xlatSvc, notifySvc, WindowFactory, ocDateSvc: OcDateSvc, errorReporter) {

        var vm = this;
        $scope.vm = this;

        vm.url = amtConstants.url;

        vm.model = {
            forecastId: 0,
            forecastVehicleId: 0,
            vehicleEndDate: "1999-01-02"
        };

        this.$onInit = function () {

            vm.model.forecastId = vm.wnd.initParams.forecastId;
            vm.model.forecastVehicleId = vm.wnd.initParams.vehicleId;
            vm.model.vehicleEndDate = !!vm.wnd.initParams.vehicleenddate ? new Date(vm.wnd.initParams.vehicleEndDate) : null;

            vm.forecastStartDate = vm.wnd.initParams.forecastStartDate;
            vm.forecastEndDate = vm.wnd.initParams.forecastEndDate;

            vm.buttons = [
                {
                    primary: true,
                    cancel: false,
                    value: 'common.save_label',
                    name: 'saveButton',
                    click: 'save',
                    type: enums.buttonTypes.button
                },
                {
                    primary: false,
                    cancel: true,
                    value: 'common.cancel_label',
                    name: 'cancelButton',
                    click: 'cancel',
                    type: enums.buttonTypes.button
                }
            ];

            vm.buttonStates = {
                saveButton: {
                    visible: true,
                    disabled: true
                },
                cancelButton: {
                    visible: true,
                    disabled: false
                }
            };

            vm.buttonMethods = {
                save: vm.save,
                cancel: vm.onCancelPopup
            };
        };

        vm.save = function () {

            if (+vm.model.forecastId !== 0) {

                vm.wnd.processing = true;

                var updateModel = {
                    forecastId: vm.model.forecastId,
                    forecastVehicleId: vm.model.forecastVehicleId,
                    vehicleEndDate: ocDateSvc.removeLocalTimeZoneOffset(vm.model.vehicleEndDate)
                };

                amtCommandQuerySvc.put(amtConstants.url.updateVehicleEndDate, updateModel).then(function (response) {

                    notifySvc.success(xlatSvc.xlat("forecastVehicles.messageVehicleEndDateUpdateSuccess"));

                    if (vm.wnd.onDataChanged) {
                        vm.wnd.onDataChanged();
                    }

                    WindowFactory.closeWindow(vm.wnd);

                }).catch(function (error) {
                    errorReporter.logError(error);
                }).finally(function () {
                    vm.wnd.processing = false;
                });
            }
        }

        vm.onCancelPopup = function () {
            confirmSvc.confirmSaveChange(vm.form.$dirty).then(function () {
                vm.form.dirty = false;
                WindowFactory.closeWindow(vm.wnd);
            });
        }

        $scope.$watchGroup(['vm.form.$invalid', 'vm.form.$pristine', 'vm.wnd.processing'], function () {
            vm.buttonStates.saveButton.disabled = vm.form.$invalid || vm.form.$pristine || !!vm.wnd.processing;
        });
    }
